export enum TransactionMode {
    AddData = 0,
    EditData = 1,
    DeleteData = 2
}